export default __webpack_public_path__ + "static/media/kako_funkcionisu_2.8a3dbf05.png";